import {Button} from "../../../basic/button.tsx";
import {Plus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface ProductActionsProps {
    onCreateProduct: () => void;
}

export function ProductActions({onCreateProduct}: ProductActionsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="flex items-center gap-2">
            <Button onClick={onCreateProduct}>
                <Plus className="h-4 w-4 mr-2"/>
                {t('admin.products.addProduct')}
            </Button>
        </div>
    );
}